import { Injectable, inject } from '@angular/core';

import { Fai, ProductFactory, Pto, QuoteModel } from '@bytel/bytel-sales';
import { Oauth2Service } from '@bytel/checkout';

import { FaiService } from '@services/fai.services';
import { MainCartService } from '@services/main-cart.service';
import { MixedCartService } from '@services/mixed-cart.service';
import { PtoService } from '@services/pto.service';

import { tunnelRoutes } from '@tunnel/routes';

import { Observable, of, takeLast } from 'rxjs';

import { BasicObject } from '../../../interfaces/checkout.interface';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class PtoStep extends Step {
    public static readonly key: string = 'pto';
    public label: string = 'Logement';
    public next: Step;
    public routerLink: string = `/tunnel/${tunnelRoutes.pto}`;
    public hasReminder = true;
    public icon: string = 'tri-home-tools';
    protected faiService = inject(FaiService);
    protected cartService = inject(MainCartService);
    protected ptoService = inject(PtoService);
    protected mixedCartService = inject(MixedCartService);
    protected oauth2Service = inject(Oauth2Service);

    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(this.canDisplay() && this.oauth2Service.isConnected);
    }

    public canDisplay(): boolean {
        const quoteFai = this._getQuoteFai();

        if (quoteFai) {
            const principalSubscription: Fai = quoteFai.getPrincipalProduct<Fai>('Fai');

            if (
                !ProductFactory.Is(principalSubscription, Fai, true) ||
                principalSubscription.technology !== Fai.TECHNOLOGIES.FTTH
            ) {
                return false;
            }

            return (
                this.faiService.eligibility?.cartId !== undefined &&
                this.faiService.eligibility?.address?.id !== undefined &&
                !this.faiService.eligibility.shouldBypass
            );
        }
    }

    public setByPass(): void {
        this.isBypass = this.faiService.eligibility?.shouldBypass;
        if (this.isBypass && !this.ptoService.getPto()) {
            this.bypass().pipe(takeLast(1)).subscribe();
        }
    }

    public bypass(): Observable<boolean> {
        const vertical = this.faiService.getVertical();
        const pto: Pto = {
            batiment: vertical.building,
            escalier: vertical.stair,
            etage: vertical.floor,
            dateOuvertureCommerciale: '',
            idPtoObligatoire: false,
            presencePto: vertical.hasPto,
            has_pto: vertical.hasPto,
            pto: this.faiService.eligibility.pto,
        };
        return this.ptoService.save(pto);
    }

    public getReminderData(): string {
        const storedPto: BasicObject = this.ptoService.getPto();
        if (storedPto?.pto) {
            return "J'ai fourni ma PTO";
        }
        return "Je n'ai pas trouvé ma référence fibre";
    }

    private _getQuoteFai(): QuoteModel {
        return this.cartService.cartModel.quotes.find((quote) => quote.isAcquisitionFix());
    }
}
